import * as React from 'react';
import { gold, fontBrand} from '../../../../getLPTheme.tsx';
import 'react-multi-carousel/lib/styles.css';
import {Autocomplete, AutocompleteRenderInputParams, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import TextField from '@mui/material/TextField';
import { Box} from "@mui/material";
import {ButtonBrand} from '../../../../getLPTheme.tsx';
import swal from 'sweetalert';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { options } from '@config';

//-------------------- Formulario Emergente Nuevo Club--------------------

export default function DialogNuevoClub() {
  const [openDialog, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };


  // Fade Menu typemarker



  // Close Fade Menu typemarker

  const navigate = useNavigate();


  const [formData, setFormData] = React.useState({
    name: '',
    typeMarker: '',
    address: '',
    contact: '',
    url: '',
    coordinates: '',
    discount: '',
    country: '',
    state: '',
    locate: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeDrop = (evento, valor) => {
    setFormData({ ...formData, "typeMarker": valor });
  };


  const handleSubmit = async (e) => {

    const response = await fetch((options.api.url + "point")
    , {
        method: 'POST',
        mode: "cors",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (response.status === 200) {
        swal("Éxito", "Registro exitoso", "success")
    } else {
        console.log("Error punto creado")
        swal("Error", data.error, "error");
    }

    handleCloseDialog();
  };
  
  
  return (
    <React.Fragment>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <ButtonBrand
          sx={{
            width: "100%",
            maxWidth: 520,
            color: "white",
            backgroundColor: gold[500],
          }}
          type="submit"
          variant="contained"
          onClick={handleClickOpen}
        >
          Cargar Nuevo Marcador
        </ButtonBrand>
        
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperProps={{style: {backgroundColor: 'rgb(33 36 41)', boxShadow: 'none'},}}
          
          >
          <form onSubmit={handleSubmit}>
            <DialogTitle sx={{color: "white", fontFamily: fontBrand.principal}}>Nuevo Marcador</DialogTitle>
            <DialogContent>
              <DialogContentText sx={{color: "white", fontFamily: fontBrand.principal}}>
                Completa todos los campos a continuacion:
              </DialogContentText>
              <br/>
              <Autocomplete
                id="typeMarker"
                options={['club', 'restaurant', 'hotel', 'comercio']}
                value={formData.typeMarker || null}
                onChange={(_, newValue) =>
                  setFormData({ ...formData, typeMarker: newValue ?? '' })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Marcador"
                    variant="standard"
                    // color del label
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      sx: { color: gold[1000], fontFamily: fontBrand.principal },
                    }}
                    // color del texto dentro del input
                    InputProps={{
                      ...params.InputProps,
                      sx: { color: 'white', fontFamily: fontBrand.principal },
                    }}
                  />
                )}
                // íconos (flecha / clear) en blanco
                sx={{
                  '& .MuiSvgIcon-root': { color: 'white' },
                }}
                componentsProps={{
                  paper: { sx: { backgroundColor: '#0B0F14', color: 'white' } },
                }}
              />

                
              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                label="Nombre"
                fullWidth
                variant="standard"
                name="name"
                value={formData.name}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />

              <TextField
                autoFocus
                required
                margin="dense"
                id="country"                
                label="País"
                fullWidth
                variant="standard"
                name="country"
                value={formData.country}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="state"                
                label="Provincia / Estado"
                fullWidth
                variant="standard"
                name="state"
                value={formData.state}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="locate"                
                label="Localidad"
                fullWidth
                variant="standard"
                name="locate"
                value={formData.locate}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />      
              <TextField
                autoFocus
                required
                margin="dense"
                id="address"
                label="Direccion"
                fullWidth
                variant="standard"
                name="address"
                value={formData.address}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="contact"
                label="Contacto"
                fullWidth
                variant="standard"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                margin="dense"
                id="url"               
                label="URL"
                fullWidth
                variant="standard"
                name="url"
                value={formData.url}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="coordinates"                
                label="Coordenadas Google Maps"
                fullWidth
                variant="standard"
                name="coordinates"
                value={formData.coordinates}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="discount"                
                label="Beneficio / % de descuento"
                fullWidth
                variant="standard"
                name="discount"
                value={formData.discount}
                onChange={handleChange}
                InputProps={{
                  sx: {
                    color: "white",
                    fontFamily: fontBrand.principal
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: gold[1000],
                    fontFamily: fontBrand.principal
                  },
                }}
              />                                      
            </DialogContent>
            <DialogActions>
              <ButtonBrand onClick={handleSubmit}>Agregar</ButtonBrand>
              <ButtonBrand onClick={handleCloseDialog}>Cancel</ButtonBrand>
            </DialogActions>
          </form>  
        </Dialog>
      </Box>
    </React.Fragment>
  );
  }
  
  //-------------------- Fin Formulario Emergente Nuevo Club  --------------------